import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { listTimetableWeeks, getPublishedRuns } from "./happyschoolApi";
import { getActiveSchoolId } from "./activeSchool";
import HappySchoolTKBManager from "./HappySchoolTKBManager";

// (21/10/2026) /happyschool/tkb — LƯỚI các TKB (mỗi tuần TKB 1 ô). Bấm 1 ô -> /happyschool/tkb/:weekId mở cây
// "Quản lý TKB" CHỈ có đúng TKB đó (không lẫn các tuần khác).
const fmt = (d) => { const p = String(d || "").split("-"); return p.length === 3 ? `${p[2]}/${p[1]}` : d || ""; };
const fmtFull = (d) => { const p = String(d || "").split("-"); return p.length === 3 ? `${p[2]}/${p[1]}/${p[0]}` : d || ""; };
const weekLabel = (w) => (w.name ? w.name : `Tuần ${fmt(w.startDate)}–${fmt(w.endDate)}`);
function khoiLabel(w) {
  let arr = Array.isArray(w.khois) ? w.khois : w.khoi && w.khoi !== "all" ? [String(w.khoi)] : [];
  arr = arr.filter((k) => ["12", "11", "10"].includes(String(k)));
  if (arr.length === 0 || arr.length >= 3) return "Tất cả khối";
  return arr.slice().sort((a, b) => Number(b) - Number(a)).map((k) => `Khối ${k}`).join(", ");
}
const todayIso = () => new Date(Date.now() + 7 * 3600 * 1000).toISOString().slice(0, 10);

const HappySchoolTkbList = () => {
  const { weekId } = useParams();
  const navigate = useNavigate();
  const schoolId = getActiveSchoolId();
  const [weeks, setWeeks] = useState(null);
  const [published, setPublished] = useState({});
  const [error, setError] = useState("");
  const [q, setQ] = useState("");
  const [filter, setFilter] = useState("all"); // all | published | baogiang

  useEffect(() => {
    if (!schoolId) return;
    Promise.all([listTimetableWeeks(schoolId), getPublishedRuns(schoolId).catch(() => [])])
      .then(([list, pubs]) => {
        setWeeks((list || []).slice().sort((a, b) => String(b.startDate || "").localeCompare(String(a.startDate || "")) || (b.createdAt || 0) - (a.createdAt || 0)));
        setPublished(Object.fromEntries((pubs || []).map((p) => [p.weekId, p])));
      })
      .catch((e) => setError(e.message));
  }, [schoolId]);

  const shown = useMemo(() => {
    const qn = q.trim().toLowerCase();
    return (weeks || []).filter((w) => {
      if (filter === "published" && !published[w.id]) return false;
      if (filter === "baogiang" && !w.excludeFromChamCong) return false;
      if (!qn) return true;
      return `${weekLabel(w)} ${fmtFull(w.startDate)} ${fmtFull(w.endDate)} ${khoiLabel(w)}`.toLowerCase().includes(qn);
    });
  }, [weeks, published, q, filter]);

  if (!schoolId) return <div style={pageStyle}>Chưa chọn trường. Vào <Link to="/happyschool/schools">Trường của tôi</Link>.</div>;

  // Đã chọn 1 TKB -> cây chỉ có đúng TKB đó.
  if (weekId) {
    const w = (weeks || []).find((x) => x.id === weekId);
    return (
      <div style={pageStyle}>
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 12, flexWrap: "wrap" }}>
          <button type="button" onClick={() => navigate("/happyschool/tkb")} style={backBtn}>← Danh sách TKB</button>
          <h2 style={{ margin: 0, fontSize: 20 }}>📅 {w ? weekLabel(w) : "Thời khoá biểu"}</h2>
          {w && <span style={pill}>{fmtFull(w.startDate)} – {fmtFull(w.endDate)} · {khoiLabel(w)}</span>}
        </div>
        <HappySchoolTKBManager key={weekId} onlyWeekId={weekId} />
      </div>
    );
  }

  const today = todayIso();
  return (
    <div style={pageStyle}>
      <h2 style={{ margin: "0 0 6px" }}>🗓️ Danh sách thời khoá biểu</h2>
      <p style={{ color: "#6b7280", fontSize: 13, margin: "0 0 14px" }}>Bấm vào 1 TKB để mở cây quản lý chỉ có đúng TKB đó.</p>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 14, alignItems: "center" }}>
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Tìm theo tên / ngày (vd 26/10)" style={inputStyle} />
        {[["all", "Tất cả"], ["published", "Đã công bố"], ["baogiang", "Báo giảng"]].map(([k, l]) => (
          <button key={k} type="button" onClick={() => setFilter(k)} style={filter === k ? chipOn : chip}>{l}</button>
        ))}
        {weeks && <span style={{ color: "#6b7280", fontSize: 13, marginLeft: "auto" }}>{shown.length} / {weeks.length} TKB</span>}
      </div>
      {error && <p style={{ color: "#dc2626" }}>{error}</p>}
      {weeks === null ? (
        <p>Đang tải...</p>
      ) : shown.length === 0 ? (
        <p style={{ color: "#6b7280" }}>Không có TKB nào.</p>
      ) : (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(230px, 1fr))", gap: 12 }}>
          {shown.map((w) => {
            const pub = published[w.id];
            const current = w.startDate <= today && today <= w.endDate;
            return (
              <Link key={w.id} to={`/happyschool/tkb/${w.id}`} style={{ ...card, ...(current ? cardCurrent : {}) }}>
                <div style={{ display: "flex", justifyContent: "space-between", gap: 6, alignItems: "flex-start" }}>
                  <div style={{ fontWeight: 700, fontSize: 15, color: "#0f172a" }}>📅 {weekLabel(w)}</div>
                  {current && <span style={{ ...badge, background: "#dbeafe", color: "#1d4ed8" }}>Tuần này</span>}
                </div>
                <div style={{ fontSize: 13, color: "#475569", margin: "6px 0 8px" }}>{fmtFull(w.startDate)} – {fmtFull(w.endDate)}</div>
                <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                  <span style={{ ...badge, background: "#f0fdfa", color: "#0f766e" }}>{khoiLabel(w)}</span>
                  {pub ? (pub.demo ? <span style={{ ...badge, background: "#fef3c7", color: "#92400e" }}>🧪 Demo</span> : <span style={{ ...badge, background: "#dcfce7", color: "#166534" }}>✓ Đã công bố</span>) : <span style={{ ...badge, background: "#f3f4f6", color: "#6b7280" }}>Chưa công bố</span>}
                  {w.excludeFromChamCong && <span style={{ ...badge, background: "#fef3c7", color: "#92400e" }}>Báo giảng</span>}
                  {w.busyOpen && <span style={{ ...badge, background: "#ede9fe", color: "#5b21b6" }}>Mở khai bận</span>}
                </div>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
};

const pageStyle = { padding: 24, maxWidth: 1200, margin: "0 auto", background: "#E3F2FD", borderRadius: 12, minHeight: "100%", boxSizing: "border-box" };
const card = { display: "block", textDecoration: "none", background: "#fff", border: "1px solid #e2e8f0", borderRadius: 10, padding: 14, boxShadow: "0 1px 2px rgba(0,0,0,0.04)" };
const cardCurrent = { border: "2px solid #3b82f6" };
const badge = { fontSize: 11, fontWeight: 600, borderRadius: 10, padding: "2px 8px" };
const pill = { fontSize: 12, color: "#0f766e", background: "#f0fdfa", border: "1px solid #99f6e4", borderRadius: 10, padding: "2px 8px" };
const inputStyle = { padding: "8px 10px", border: "1px solid #cbd5e1", borderRadius: 8, minWidth: 220, fontSize: 14 };
const chip = { padding: "7px 12px", background: "#fff", color: "#374151", border: "1px solid #d1d5db", borderRadius: 16, cursor: "pointer", fontWeight: 600, fontSize: 13 };
const chipOn = { ...chip, background: "#0ea5a3", color: "#fff", border: "1px solid #0ea5a3" };
const backBtn = { padding: "7px 12px", background: "#fff", color: "#0f766e", border: "1px solid #99f6e4", borderRadius: 8, cursor: "pointer", fontWeight: 600 };

export default HappySchoolTkbList;
